import React, { useContext } from 'react'
import { Field, FieldRenderProps } from 'react-final-form'
import { Grid, makeStyles, MenuItem } from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { formulaireChangementAppartementEnum, raisonRechercheEnum } from '../enums/formulaireChangementAppartementEnum'
import { objectGetKeys } from '../../../utils/ieCompatibility'
import selectSizeEnum from '../../../enums/selectEnums/SelectSizeEnum'
import { RaisonRechercheModel } from '../types/formulaireChangementAppartementModel'
import { ResponsiveContext } from '../../../utils/context/responsiveContext'
import styles from '../../../styles'
import FormSelectAcquisitionResidenceField from '../../../components/fields/FormSelectAcquisitionResidenceField'

const useStyles = makeStyles(
	(theme) => (
		{
			titleStyle: {
				...styles(theme).title6,
				fontSize: 28,
				margin: '5px 0 15px 0',
				color: theme.palette.blue.main
			},
			alignEnd: {
				alignSelf: 'self-end'
			},
			selectStyle: {
				...styles(theme).text1,
				fontSize: 15,
				fontWeight: 500,
				color: theme.palette.blue.main,
				lineHeight: 1.33,

				'& .MuiSelect-icon': {
					color: theme.palette.blue.main
				}
			},
			itemStyle: {
				opacity: 1
			}
		}
	)
)

type RaisonRechercheProps = FieldRenderProps<RaisonRechercheModel>

const RaisonRecherche: React.FC<RaisonRechercheProps> = (
	{
		input
	}
) => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const classes = useStyles({ isLargeScreen })
	const intl = useIntl()

	return (
		<>
			<Grid item xs={12}>
				<h1 className={classes.titleStyle}>
					<FormattedMessage
						id="changementAppartement.formulaire.raisonRecherche.title"
						defaultMessage="Quel est le motif de votre recherche ?"
						description="Search reason title"
					/>
				</h1>

				<Grid container item xs={12} className={classes.alignEnd}>
					<Field
						name={`${input.name}.${formulaireChangementAppartementEnum.raisonRechercheReponse}`}
						component={FormSelectAcquisitionResidenceField}
						size={isLargeScreen ? selectSizeEnum.big : selectSizeEnum.small}
						inputTextStyle={classes.selectStyle}
						label={
							`${intl.formatMessage(
								{
									id: 'changementAppartement.formulaire.raisonRecherche.label',
									defaultMessage: 'Réponse',
									description: 'Search reason label'
								}
							)} *`
						}
						fullWidth
					>
						<MenuItem className={classes.itemStyle} value="" disabled>
							<FormattedMessage
								id="changementAppartement.formulaire.raisonRecherche.placeholder"
								defaultMessage="Choisir"
								description="Search reason placeholder"
							/>
						</MenuItem>

						{
							objectGetKeys(raisonRechercheEnum).filter((searchReason) => isNaN(Number(searchReason))).map(
								(searchReason) =>
									<MenuItem
										value={raisonRechercheEnum[searchReason as keyof typeof raisonRechercheEnum]}
										key={searchReason}
										className={classes.itemStyle}
									>
										<FormattedMessage
											id={`changementAppartement.formulaire.raisonRecherche.${searchReason}`}
											defaultMessage="vente du logement"
											description="Search reason item"
										/>
									</MenuItem>
							)
						}
					</Field>
				</Grid>
			</Grid>
		</>
	)
}

export default RaisonRecherche
